import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import { useState } from "react";

const galleryItems = [
  {
    category: "action",
    label: "בפעולה",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/8b202f0c-f5d9-434b-a546-d0b4f1d11904_WhatsApp-Image-2026-04-09-at-18.37.49-1.jpeg?v=83108f572fb8b289bfbb21eafaa3e533",
    caption: "ליאור על הגריל - לילה של בשרים",
  },
  {
    category: "smoked",
    label: "מהמעשנה",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/ae436bef-1edf-4248-ad10-c70fa2b8aff2_WhatsApp-Image-2026-04-09-at-18.37.50-4.jpeg?v=7d37deb625639c8099fe24b890ca2466",
    caption: "נתחים מעושנים מהגריל",
  },
  {
    category: "event",
    label: "אירועים",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/fe56a861-8596-42ad-8774-7c10e3f92b2b_WhatsApp-Image-2026-04-09-at-18.37.50-5.jpeg?v=d1407dd8aff85efab9bdaeae709849df",
    caption: "אירוע ערב - כולם מסביב לשולחן",
  },
  {
    category: "smoked",
    label: "מהמעשנה",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/edd55fa0-c352-42ad-95cf-b45338a38ccb_WhatsApp-Image-2026-04-09-at-18.37.50-6.jpeg?v=d44e4adf37d08a0b504d4ff454a33b7f",
    caption: "שולחן בשרים עמוס ועשיר",
  },
  {
    category: "event",
    label: "אירועים",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/92f80f9d-3a40-46f4-8a0d-0f5bbdf70612_WhatsApp-Image-2026-04-09-at-18.37.51-2.jpeg?v=5c927b91796d4d77356bd74a785c4d04",
    caption: "אורחים מאושרים באירוע",
  },
  {
    category: "action",
    label: "בפעולה",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/3b786136-1b13-4081-b4c3-11c7526b6aa2_WhatsApp-Image-2026-04-09-at-18.37.51-5.jpeg?v=e9462229e8469fd2bbed0dc30a600921",
    caption: "הכנת הבשרים בפעולה",
  },
  {
    category: "event",
    label: "אירועים",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/ee3da90d-1b93-455a-90eb-acbd68d165a7_WhatsApp-Image-2026-04-09-at-18.38.29-3.jpeg?v=d5d6ae94e9369edf24873010c149cbbb",
    caption: "חגיגה עם חברים",
  },
  {
    category: "smoked",
    label: "מהמעשנה",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/5fade141-47d8-4bf8-b209-af998c584378_WhatsApp-Image-2026-04-09-at-18.38.29-4.jpeg?v=6981743592a88250a5ab0d380f0e5294",
    caption: "מבחר בשרים מהמעשנה",
  },
  {
    category: "action",
    label: "בפעולה",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/24be523d-e741-4009-a9b0-c8f037448066_WhatsApp-Image-2026-04-09-at-18.38.29-5.jpeg?v=afced46a595128365cbfe982a0c02daa",
    caption: "ליאור מגיש לאורחים",
  },
  {
    category: "event",
    label: "אירועים",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/67386d85-7ff3-4ec0-a6b2-dc74c4bac187_WhatsApp-Image-2026-04-09-at-18.37.50-2.jpeg?v=1aaf1ae2de9c04658dd934d176e6e6cb",
    caption: "אירוע ערב קיץ",
  },
  {
    category: "smoked",
    label: "מהמעשנה",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/89f38832-f8ff-422a-aedc-6cf0b5dc9cb5_WhatsApp-Image-2026-04-09-at-18.37.50-3.jpeg?v=97e53c7b8a094ffb65632f09dae7d3ee",
    caption: "נתחים על הגריל",
  },
  {
    category: "action",
    label: "בפעולה",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/33c49ad0-b6c3-4697-93c9-68d336cd819a_WhatsApp-Image-2026-04-09-at-18.37.49-2.jpeg?v=14413776c712959fe1dc437fcdcfa165",
    caption: "עמדת ההגשה מלאה בשפע",
  },
  {
    category: "event",
    label: "אירועים",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/21c2a2cf-01bf-4d70-8ed3-8c50e10a4c2d_WhatsApp-Image-2026-04-09-at-18.37.49.jpeg?v=2720b99e3a54852bdcdd97e8b921c7f9",
    caption: "אירוע גדול עם המון שמחה",
  },
  {
    category: "action",
    label: "בפעולה",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/cfb91ae5-f1d5-4dbc-a421-3a8798a5f1e7_WhatsApp-Image-2026-04-09-at-18.37.50-1.jpeg?v=ff1c8a9a026828d36a63a6e6578a8f3c",
    caption: "חיתוך פרונטלי מול האורחים",
  },
  {
    category: "event",
    label: "אירועים",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/a37e5a39-222d-452b-b20c-18167ca7527a_WhatsApp-Image-2026-04-09-at-18.38.29-2.jpeg?v=0aaa42921bf79e2d45de9a365c2bf8e6",
    caption: "שמחה ומסיבה",
  },
];



const Gallery = () => {
  const [lightbox, setLightbox] = useState<null | typeof galleryItems[0]>(null);

  return (
    <div className="min-h-screen bg-[#faf7f2]" dir="rtl">
      <Navbar />

      {/* Hero */}
      <section className="pt-24 pb-14 bg-[#1a0a00] text-center">
        <div className="max-w-7xl mx-auto px-6">
          <span
            className="inline-block bg-[#e85d04]/20 text-[#f4a261] border border-[#e85d04]/30 px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            <i className="ri-image-fill ml-1"></i>
            גלריה
          </span>
          <h1
            className="text-white font-black text-4xl md:text-6xl mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            רגעים שמדברים
            <br />
            <span className="text-[#e85d04]">בעצמם</span>
          </h1>
          <p
            className="text-white/70 text-lg max-w-xl mx-auto"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            תמונות אותנטיות מאירועים אמיתיים - כי לקוחות קונים קודם כל עם העיניים
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="py-14">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {galleryItems.map((item, i) => (
              <div
                key={i}
                className="relative group rounded-2xl overflow-hidden cursor-pointer"
                style={{ height: "280px" }}
                onClick={() => setLightbox(item)}
              >
                <img
                  src={item.img}
                  alt={item.caption}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram CTA */}
      <section className="py-14 bg-[#1a0a00]">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-[#e85d04]/20 rounded-full mx-auto mb-5">
            <i className="ri-instagram-fill text-[#e85d04] text-3xl"></i>
          </div>
          <h2
            className="text-white font-black text-3xl mb-3"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            עוד תמונות ורילסים באינסטגרם
          </h2>
          <p
            className="text-white/60 text-base mb-6"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            עקבו אחרינו לתוכן חדש מכל אירוע
          </p>
          <a
            href="https://www.instagram.com/meet_n_meatoffical/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#e85d04] hover:bg-[#d44d00] text-white px-8 py-4 rounded-full text-base font-bold transition-colors duration-200 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            <i className="ri-instagram-fill"></i>
            @meet_n_meatoffical
          </a>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <div className="relative max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <button
              className="absolute -top-10 left-0 text-white/70 hover:text-white text-3xl cursor-pointer"
              onClick={() => setLightbox(null)}
            >
              <i className="ri-close-line"></i>
            </button>
            <img
              src={lightbox.img}
              alt={lightbox.caption}
              className="w-full rounded-2xl object-cover"
              style={{ maxHeight: "80vh" }}
            />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Gallery;
